import AuthService from '../../service';
const FreePage = {
  getFreePage(page,search,sort){
    return AuthService.get(`free_page?`+
      `page=${page}` +
      `&sort=${sort}` +
      `&search=${search}`
    );
  },
  showFreePage(id){
    return AuthService.get(`free_page/${id}`);
  },
  createFreePage(data){
    return AuthService.post(`free_page`,data);
  },
  updateFreePage(id,data){
    return AuthService.put(`free_page/${id}`,data);
  },
  deleteFreePage(id){
    return AuthService.delete(`free_page/${id}`);
  },
  checkSlugFreePage(slug){
    return AuthService.get(`slugcheck/${slug}`);
  }
}
export default FreePage
